// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

// HS Code
import { LanguageModel, Constants, SelectListItem } from '../../models';

// #endregion

@Component({
  selector: 'hs-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguagePickerComponent implements OnInit, OnChanges {
  private readonly _DECIMAL_RADIX: number = 10;
  @Input() languages: LanguageModel[];
  @Input() selectedLanguage: LanguageModel;

  @Output() languageChanged = new EventEmitter<LanguageModel>();

  values: SelectListItem[];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.languages && simpleChanges.languages.currentValue) {
      if (!this.selectedLanguage) {
        this.selectedLanguage = Constants.DEFAULT_LANGUAGE;
      }

      this.values = this.languages.map(l => {
        const isSelected = l.id === this.selectedLanguage.id;

        return {
          isSelected,
          isDisabled: false,
          group: null,
          text: l.isoThreeLetterName + ' (' +  l.cultureCode + ')',
          value: l.id.toString(),
        } as SelectListItem;
      });
    }
  }

  onSelectedLanguageChanged(selectedId: string): void {
    const languageId = parseInt(selectedId, this._DECIMAL_RADIX);
    const selectedLanguage = this.languages.find(l => {
      return l.id === languageId;
    });
    if (selectedLanguage && selectedLanguage.id !== this.selectedLanguage.id) {
      this.languageChanged.emit(selectedLanguage);
    }
  }
}
